import React from 'react';

import classNames from 'classnames';

import {
  BusinessPDPOpenFormSectionContainer,
} from '../../containers/BusinessPDPOpenFormSectionContainer/BusinessPDPOpenFormSectionContainer';
import { UrlType } from '../../types/apiEnums';
import { LinkPresentational } from '../../types/common';
import { LayoutWrapper } from '../LayoutWrapper/LayoutWrapper';
import { Link as LinkComponent, LinkIntent, LinkType } from '../Link/Link';
import { Chevron } from '../icons';
import styles from './Breadcrumbs.module.css';

export type Props = {
  breadcrumbs: LinkPresentational[] | null;
  isShowBusinessForm?: boolean;
};

export const Breadcrumbs = React.memo((props: Props) => {
  const { breadcrumbs, isShowBusinessForm } = props;

  const length = breadcrumbs?.length;

  return breadcrumbs && length ? (
    <LayoutWrapper>
      <div className={classNames(styles.breadcrumbs, {
        [styles.withBusinessForm]: isShowBusinessForm,
      })}>
        <div className={styles.breadcrumbsInnerWrapper}>
          {breadcrumbs.map((element, index) => {
            const isLast = index === length - 1;
            const color = isLast
              ? LinkIntent.lastBreadcrumb
              : LinkIntent.breadcrumbs;
            const type = isLast
              ? LinkType.Span
              : element.url.type === UrlType.ABSOLUTE
                ? LinkType.ExternalHref
                : LinkType.Href;

            return (
              <React.Fragment key={index}>
                <LinkComponent
                  type={type}
                  to={element.url.href}
                  intent={color}
                  className={styles.link}
                >
                  {element.title}
                </LinkComponent>

                {!isLast
                && <Chevron
                  variant='right'
                  className={styles.chevron}
                  width={22}
                  height={22}
                />}
              </React.Fragment>
            );
          })}
        </div>
        {isShowBusinessForm && <BusinessPDPOpenFormSectionContainer />}
      </div>
    </LayoutWrapper>
  ) : null;
});

Breadcrumbs.displayName = 'Breadcrumbs';
